<ngb-alert [dismissible]="false" *ngIf="restrictUserAlert" class="text-center form-alert">
  Please fill in the required fields to continue your work
</ngb-alert>

<span>
  <h1 class="pt-3 mb-3">Change name & email</h1>
  <form [formGroup]="emailForm" (ngSubmit)="submit()">
    <div class="row form-group">
      <label for="account-name" class="col-sm-4 col-md-4 col-form-label">Name</label>
      <div class="col-md-6 col-lg-4">
        <input
          type="text"
          name="accountName"
          id="account-name"
          formControlName="name"
          class="form-control"
          [class.is-invalid]="emailForm.get('name').invalid && emailForm.get('name').touched"
        />
        <control-messages [control]="emailForm.get('name')"></control-messages>
      </div>
    </div>

    <div class="row form-group">
      <label for="account-email" class="col-sm-4 col-md-4 col-form-label">Email</label>
      <div class="col-md-6 col-lg-4">
        <input
          type="email"
          name="accountEmail"
          id="account-email"
          formControlName="email"
          class="form-control"
          [class.is-invalid]="emailForm.get('email').invalid && emailForm.get('email').touched"
        />
        <control-messages [control]="emailForm.get('email')"></control-messages>
      </div>
    </div>

    <div class="row form-group">
      <label for="account-username" class="col-sm-4 sol-md-4 col-form-label">Username</label>
      <div class="col-md-6 col-lg-4">
        <input
          type="text"
          name="accountUsername"
          id="account-username"
          class="form-control"
          formControlName="username"
          [class.is-invalid]="emailForm.get('username').invalid && emailForm.get('username').touched"
        />
        <control-messages [control]="emailForm.get('username')"></control-messages>
      </div>
    </div>

    <div class="row form-group">
      <label class="col-sm-4 col-md-4 col-form-label"></label>
      <div class="col-md-6 col-lg-4 ml-0">
        <button
          class="btn btn-info w-100"
          type="submit"
          angularticsCategory="settings"
          angulartics2On="click"
          angularticsAction="Save New Profile data"
          [disabled]="emailForm.pristine || emailForm.invalid"
        >Save</button>
      </div>
    </div>
  </form>
</span>
